import Decimal from 'decimal.js';

const SIXTY = 60;

/**
 * "Task, location, tool, variation" assignment display text for tables.
 * @param assignment
 * @returns The display text for the assignment
 */
export const assignmentText = (assignment:any) => `${assignment.task.text}, ${assignment.location.text}, ${assignment.tool.text}, ${assignment.variation.text}`;

/**
 * The difference between the worker's discomfort level at the start of the shift and the end of the shift.
 * @param start Discomfort level at the start of the shift
 * @param end Discomfort level at the end of the shift
 * @returns The discomfort level change by the end of the shift
 */
export const discomfortChange = (start:number, end:number) => end - start;

/**
 * Formats number with commas.
 * @param number
 * @returns string
 */
export const formatNumber = (number:string) => number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * Converts the provided hours to minutes.
 * @param hours The number of hours
 * @returns string
 */
export const hoursToMinutes = (hours:string|number) => new Decimal(hours).times(SIXTY).toString();

/**
 * Converts the provided hours to seconds/
 * @param hours The number of hours
 * @returns string
 */
export const hoursToSeconds = (hours:string|number) => new Decimal(hoursToMinutes(hours)).times(SIXTY);

/**
 * Retrieves the measurement type of the assignment.
 * @param measurementTypes List of measurement types
 * @param value The value of the measurement to match against
 * @returns The measurement type that matches the provided value
 */
export const measurement = (measurementTypes:any, value:string) => measurementTypes.find((type: { value: any }) => type.value === value);

/**
 * Converts the provided time (hours and minutes) to hours in decimals.
 * @param hours The number of hours
 * @param minutes The number of minutes
 * @returns The time in hours
 */
export const timeByHours = (hours:number, minutes:number) => {
    const mins = new Decimal(minutes);
    const m = mins.div(SIXTY);
    const hrs = new Decimal(hours);
    const h = hrs.plus(m);
    return toFixedOne(h.toString());
};

/**
 * Round the number to one decimal.
 * @param number
 */
export const toFixedOne = (number:number|string) => new Decimal(number).toDecimalPlaces(1, Decimal.ROUND_HALF_UP);